import React, { FC } from 'react'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment-timezone'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { TShift } from '../../utils/getFacilityHours'
import { Dash } from '../Dash'

const useStyles = makeStyles({
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  listItem: {
    padding: 0,
    margin: 0,
  },
  closed: {
    color: brandColors.coolGray5,
  },
})

export interface IPreviewDayShiftsProps {
  shifts: TShift[]
}

export const PreviewDayShifts: FC<IPreviewDayShiftsProps> = ({ shifts }) => {
  const classes = useStyles()

  return (
    <ul className={classes.list}>
      {shifts.map((shift: TShift) => {
        const start = moment(shift.startTime, 'HH:mm').format('HH:mm')
        const end = moment(shift.endTime, 'HH:mm').format('HH:mm')

        return (
          <li className={classes.listItem} key={`${shift.day}${start}`}>
            {shift.closed && <span className={classes.closed}>Closed</span>}
            {!shift.startTime && !shift.endTime && !shift.closed && (
              <span className={classes.closed}>
                <Dash />
              </span>
            )}
            {!shift.closed && shift.startTime && shift.endTime && (
              <span>
                {start}&nbsp;-&nbsp;{end}
              </span>
            )}
          </li>
        )
      })}
      {isEmpty(shifts) && (
        <li className={classes.listItem}>
          <span>
            <Dash />
          </span>
        </li>
      )}
    </ul>
  )
}
